var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawerLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9719 18.76C6.32387 19.32 2.96387 21 2.96387 22.96C2.96387 25.424 8.11587 27.384 14.4999 27.384C20.8839 27.384 26.0359 25.424 26.0359 22.96C26.0359 21.056 22.8999 19.432 18.5319 18.816",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85206 2.52001C7.66806 4.20001 6.38006 6.94401 6.66006 9.74401C6.77206 11.144 7.27606 12.712 8.34006 14.336C8.45206 14.504 8.56406 14.672 8.67606 14.84L14.7241 24.584L21.4441 13.496C22.1721 12.264 22.6761 10.92 22.7881 9.52001C22.9561 7.39201 22.3961 4.48001 19.2041 2.12801C16.0681 -0.223989 13.1001 0.560011 10.9721 1.79201",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7237 13.048C16.7959 13.048 18.4757 11.318 18.4757 9.18401C18.4757 7.04998 16.7959 5.32001 14.7237 5.32001C12.6515 5.32001 10.9717 7.04998 10.9717 9.18401C10.9717 11.318 12.6515 13.048 14.7237 13.048Z",
    stroke: "#EE2A7B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerLocation);
export default __webpack_public_path__ + "static/media/drawer-location.2fc76975.svg";
export { ForwardRef as ReactComponent };